import { render, staticRenderFns } from "./ChannelProductListAssociationMultiView.vue?vue&type=template&id=413f9353&scoped=true&"
import script from "./ChannelProductListAssociationMultiView.vue?vue&type=script&lang=js&"
export * from "./ChannelProductListAssociationMultiView.vue?vue&type=script&lang=js&"
import style0 from "./ChannelProductListAssociationMultiView.vue?vue&type=style&index=0&id=413f9353&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "413f9353",
  null
  
)

export default component.exports